export default __webpack_public_path__ + "static/media/externalLink.373de102.svg";